<div *ngIf="!show">
    <div class="topHead">
        <a href="javascript:void(0);" class="adminBack" [routerLink]="['/user']"><img src="assets/images/admin/backarrow.png" /> Back to User Management</a>
        <!-- <div class="logout">
            <b>Shubham</b>
            <a href="javascript:void(0);"><img src="assets/images/admin/power.png"/> </a>
        </div> -->
        <div class="logout">
            <app-log-out class="logout"></app-log-out>
        </div>
    </div>
    <div class="centerWrap " >
        <div class="formHeading">
            <h2>Create User</h2>
        </div>
        <div class="formArea">
     <div class="dynamicBookWrap">
        <div class="container">
            <div class="row">
                <div class="resultWrap pt-3">
                    <div class="resul_img">
                        <img src="assets/images/illus.png" />
                    </div>
                     <h4>You have successfully created a new user!</h4>
                     <span class="divider"></span>
                     <p>Do you want to assign courses to the user right away?</p>
                     <a href="javascript:void(0);"  [routerLink]="['/user']" class="backPage ml-2 mr-2">Go back to User management</a>
                     <a href="javascript:void(0);" class="btn btn-primary download ml-2 mr-2"  [routerLink]="['/assign_courses']" [queryParams]="{user_id:userID}">Yes, Assign Courses</a>
                    
                     <div class="illusBtnWrap">
                    </div>
                </div>
            </div>
        </div>
        </div>
        </div>
    </div>
    </div>
    
    <div *ngIf="show">
    <div class="topHead">
        <a href="javascript:void(0);" class="adminBack" [routerLink]="['/super-admin']"><img src="assets/images/admin/backarrow.png" /> Back to Backend user Management</a>
        <!-- <div class="logout">
            <b>Shubham</b>
            <a href="javascript:void(0);"><img src="assets/images/admin/power.png"/> </a>
        </div> -->
        <div class="logout">
            <app-log-out class="logout"></app-log-out>
        </div>
    </div>
    <div class="centerWrap" >
        <div class="formHeading">
            <h2>Create User</h2>
        </div>
        <div class="formArea">
     <div class="dynamicBookWrap">
        <div class="container">
            <div class="row">
                <div class="resultWrap pt-3">
                    <div class="resul_img">
                        <img src="assets/images/illus.png" />
                    </div>
                     <h4>You have successfully created a new user!</h4>
                     <span class="divider"></span>
                     <br>
                     <br>
                     <a href="javascript:void(0);"  [routerLink]="['/super-admin']" class="backPage ml-2 mr-2">Go back to Backend user management</a>
                     <div class="illusBtnWrap">
                    </div>
                </div>
            </div>
        </div>
        </div>
        </div>
    </div>
    </div>